export const simpleLayoutContentContainerMaxWidth = '670px';

/**
 * Marks a form field's root element, and only that element: container styles
 * select on it to space fields apart from the content around them. Not a hook
 * for locating a field in a test.
 */
export const FORM_FIELD_CLASS_NAME = 'form-field';
